import { render, staticRenderFns } from "./tinkAboutKit.vue?vue&type=template&id=29ae3960"
import script from "./tinkAboutKit.vue?vue&type=script&lang=js"
export * from "./tinkAboutKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports